var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgCalenderIconSuffix = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 17,
  height: 17,
  viewBox: "0 0 17 17",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.47982 6.31295C3.67508 6.11769 3.99167 6.11769 4.18693 6.31295L8.38219 10.5082C8.44728 10.5733 8.5528 10.5733 8.61789 10.5082L12.8132 6.31295C13.0084 6.11769 13.325 6.11769 13.5203 6.31295C13.7155 6.50821 13.7155 6.8248 13.5203 7.02006L9.325 11.2153C8.86939 11.6709 8.13069 11.6709 7.67508 11.2153L3.47982 7.02006C3.28456 6.8248 3.28456 6.50821 3.47982 6.31295Z",
  fill: "#394455"
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCalenderIconSuffix, _extends({
  svgRef: ref
}, props)));
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNyAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zLjQ3OTgyIDYuMzEyOTVDMy42NzUwOCA2LjExNzY5IDMuOTkxNjcgNi4xMTc2OSA0LjE4NjkzIDYuMzEyOTVMOC4zODIxOSAxMC41MDgyQzguNDQ3MjggMTAuNTczMyA4LjU1MjggMTAuNTczMyA4LjYxNzg5IDEwLjUwODJMMTIuODEzMiA2LjMxMjk1QzEzLjAwODQgNi4xMTc2OSAxMy4zMjUgNi4xMTc2OSAxMy41MjAzIDYuMzEyOTVDMTMuNzE1NSA2LjUwODIxIDEzLjcxNTUgNi44MjQ4IDEzLjUyMDMgNy4wMjAwNkw5LjMyNSAxMS4yMTUzQzguODY5MzkgMTEuNjcwOSA4LjEzMDY5IDExLjY3MDkgNy42NzUwOCAxMS4yMTUzTDMuNDc5ODIgNy4wMjAwNkMzLjI4NDU2IDYuODI0OCAzLjI4NDU2IDYuNTA4MjEgMy40Nzk4MiA2LjMxMjk1WiIgZmlsbD0iIzM5NDQ1NSIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };